<template>
  <b-card>
    <b-form @submit.prevent="upload()">
      <b-form-group label="Upload Excel" label-for="excel">
        <b-form-file
          @change="file = $event.target.files[0]"
          id="excel"
          ref="excel-input"
          required
        />
      </b-form-group>

      <b-form-group class="d-flex justify-content-end mt-3">
        <b-button :disabled="isLoading" type="submit" variant="primary">
          Save
        </b-button>
      </b-form-group>
    </b-form>
    <span style="color:red" v-html="errString"></span>

    <b-row>
      <b-col cols="12">
        <b-card title="Product List">
          <product-tarif-files :load="load"/>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCardText,BCol, BTabs, BTab, BRow, BCard, BForm, BFormGroup, BFormFile, BButton,BModal,
  VBModal } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ProductTarifFiles from './ProductTarifFiles.vue'

export default {
  components: {
    BCardText,
    BCol,
    BTabs,
    BTab,
    BRow,
    BCard,
    BForm,
    BFormGroup,
    BFormFile,
    BModal,
    VBModal,
    BButton,
    ProductTarifFiles
  },

  data() {
    return {
      file: null,
      isLoading: false,
      errString: '',
      files: null,
      load: null,
    }
  },

  directives: {
    Ripple,
    VBModal,
  },

  mounted() {
  },

  methods: {
    toMB(bytes) {
      let mb = bytes * 0.000001
      return mb.toFixed(2)
    },
    upload() {
      let formData = new FormData()
      formData.set('file', this.file)

      this.isLoading = true

      this.$http
        .post('/tarif', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          this.errString = ''
          this.file = null
          this.load = res
          this.$refs['excel-input'].reset()
          this.$notif('Success', 'Successfully upload Product Tarif', 'success')
          this.fetchFile()
        })
        .catch(err => {
          if (typeof err.data.errors !== 'undefined') {
            this.$notif('Error', err.data.errors.file[0], 'error')
          }else{
            this.errString = err.data.replace(",","<br>")
            this.$notif('Error', `Something wrong`, 'error')
          }
        })
        .finally(() => (this.isLoading = false))
    }
  },
}
</script>
